import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DeputyGroup({
  text,
  route,
  background,
}: {
  text: string;
  route: string;
  background: string;
}) {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const bgStyle = hovered
    ? {
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, #002D4B 100%), url(${background})`,
      }
    : {
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 100%), url(${background})`,
      };

  return (
    <div
      className="relative flex-1 h-[375px] bg-cover bg-no-repeat cursor-pointer"
      style={bgStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => navigate(route)}
    >
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[40px] text-white uppercase font-bold w-3/4 text-center">
        {text}
      </div>
    </div>
  );
}
